export const PDF_ASPECT_RATIO = "1/1.4142"; // PDF aspect ratio is approximately 1:1.4142 (A4 paper size)
export const VIDEO_ASPECT_RATIO = "16/9"; // Common video aspect ratio is 16:9

/**
 * This function calculates the aspect ratio of a given width and height.
 * It returns the aspect ratio in the format "width/height" reduced to its simplest form
 * @param _width
 * @param _height
 * @returns
 */
export function calculateAspectRatio(
	_width: number | string | null | undefined,
	_height: number | string | null | undefined,
	fallback = "1/1",
): string {
	const { aspectWidth, aspectHeight } = calculateAspectRatioObject(_width, _height, fallback);
	return `${aspectWidth}/${aspectHeight}`;
}

export function calculateAspectRatioObject(
	_width: number | string | null | undefined,
	_height: number | string | null | undefined,
	fallback = "1/1",
) {
	const width = Number(_width);
	const height = Number(_height);

	if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
		return { aspectHeight: fallback.split("/")[1], aspectWidth: fallback.split("/")[0] };
	}

	const divisor = getGreatestCommonDivisor(width, height);
	const aspectWidth = width / divisor;
	const aspectHeight = height / divisor;
	return { aspectHeight, aspectWidth };
}

/**
 * This function calculates the greatest common divisor (GCD) of two numbers using the Euclidean algorithm.
 * It recursively finds the GCD by dividing the larger number by the smaller number until the remainder is zero.
 * The last non-zero remainder is the GCD.
 * @param a
 * @param b
 * @returns
 */
function getGreatestCommonDivisor(a: number, b: number): number {
	return b === 0 ? a : getGreatestCommonDivisor(b, a % b);
}
